import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import * as JsBarcode from "jsbarcode";
import MD5 from "crypto-js/md5";
import { Reader } from "src/app/models/reader";
import { ApplicationPool } from "src/app/services/application.pool";
import { HrefService } from "src/app/services/href.service";

@Component({
  selector: "reader-id",
  templateUrl: "./reader-id.component.html",
  styleUrls: ["./reader-id.component.scss"],
})
export class ReaderIdComponent {
  @ViewChild("barcode") barcode: ElementRef;

  @Input() public reader: Reader;

  get label() {
    var label = this.reader.library.label;
    if (label.indexOf(" / ") > 0) {
      return label.split(" / ")[0];
    }
    if (label.indexOf(" i. ") > 0) {
      return label.split(" i. ")[0];
    }
    if (label.indexOf(" a. ") > 0) {
      return label.split(" a. ")[0];
    }
    return label;
  }

  constructor(private href: HrefService, private pool: ApplicationPool) {}

  ngOnInit(): void {}
  ngAfterViewInit(): void {
    if (this.reader)
      JsBarcode(
        this.barcode.nativeElement,
        "L" + this.reader.id.toString() + this.getBirthdateHash(),
        {
          width: this.getBirthdateHash().length > 0 ? 1 : 1.8,
          height: 40,
          displayValue: false,
          font: "Arial",
          textPosition: "top",
          textMargin: 0,
          fontSize: 0,
          margin: 0,
        }
      );
  }

  get LogoHref() {
    return this.href.getUrl(
      "image/logo/" + this.reader.library.id + "/0",
      false
    );
  }

  get HasLogo() {
    return this.pool.SelectedLibrary.hasLogo;
  }

  getBirthdateHash() {
    if (this.reader.birthdate && this.reader.birthdate.length > 5)
      return "x" + MD5(this.reader.birthdate).toString().substring(0, 4);
    return "";
  }
}
